module.exports = __webpack_public_path__ + "static/media/TP_CC (Putat).cbb62180.png";